import { useSelector } from "react-redux";
import { useGetAssignmentQuery } from "../../../features/assignment/assignmentApi";
import { useEffect, useState } from "react";
import { useGetAssignmentsMarkQuery } from "../../../features/assignmentMark/assignmentMarkApi";
import { useGetQuizeQuery } from "../../../features/quize/quizeApi";
import { useGetQuizeMarkQuery } from "../../../features/quizeMark/quizeMarkApi";
import { Link } from "react-router-dom";
import Modal from "./Modal";

export default function AssignmentandquizBtn({ video }) {
  const [skip, setSkip] = useState(true);
  const [assignment, setAssignment] = useState(false);
  const [quize, setQuize] = useState(false);
  const [assignmentId, setAssignmentId] = useState("");
  const { user } = useSelector((state) => state.auth);

  const [opened, setOpened] = useState(false);
  const controlModal = () => {
    setOpened((prevState) => !prevState);
  };
  const assignmentSubmit = () => {
    setAssignment(false);
  };

  // assignment mark related query
  const {
    data: assignmetdata,
    isLoading: assignmentLoading,
    isError: assignmentError,
  } = useGetAssignmentQuery(video.id);

  const { data: assignmentMark, isLoading: assignmentMarkLoading } =
    useGetAssignmentsMarkQuery(
      {
        student_id: user.id,
        assignment_id: assignmentId,
      },
      { skip }
    );

  //quize mark related query
  const { data: quizedata, isLoading: quizeLoading } = useGetQuizeQuery(
    video.id
  );

  const { data: quizeMark, isLoading: quizeMarkLoading } = useGetQuizeMarkQuery(
    { videoId: video.id, studentId: user.id }
  );

  useEffect(() => {
    setAssignment(false);
    setQuize(false);
  }, [video]);
  // decide assignmet button show
  useEffect(() => {
    if (!assignmentLoading && assignmetdata?.length > 0) {
      setAssignment(true);
      setAssignmentId(assignmetdata[0].id);
      setSkip(false);
    } else {
      setSkip(true);
    }
  }, [assignmentLoading, assignmetdata]);

  useEffect(() => {
    if (!assignmentMarkLoading && assignmentMark?.length > 0) {
      setAssignment(false);
    }
  }, [assignmentMarkLoading, assignmentMark]);

  // decide quize button show
  useEffect(() => {
    if (
      !quizeLoading &&
      quizedata.length > 0 &&
      !quizeMarkLoading &&
      quizeMark.length === 0
    ) {
      setQuize(true);
    }
  }, [quizeLoading, quizedata, quizeMark, quizeMarkLoading]);

  return (
    <>
      {assignmetdata?.length > 0 && (
        <Modal
          open={opened}
          assignment={assignmetdata}
          user={user}
          control={controlModal}
          assignmentSubmit={assignmentSubmit}
        />
      )}
      <div className="flex gap-4">
        {assignment && (
          <button
            onClick={controlModal}
            className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
          >
            এসাইনমেন্ট
          </button>
        )}
        {quize && (
          <Link
            to={`/quiz/${video.id}`}
            className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary"
          >
            কুইজে অংশগ্রহণ করুন
          </Link>
        )}
      </div>
    </>
  );
}
